/**
 * One colour per bot status, everywhere.
 *
 * The task list, the major-job workspace and the task page each carried their
 * own copy of this mapping, and the copies disagreed: PENDING was grey on one
 * screen and orange on another, STOPPED was orange as a task status but red as
 * a bot status - in the same table row. Colour is meaning here, so it lives in
 * one place:
 *
 *   grey    - nothing is happening yet (PENDING, NOT_LOGGED_IN)
 *   info    - starting up / signed in, no work done yet
 *   primary - actually working
 *   warning - needs a human (2FA) or was interrupted (STOPPED)
 *   success - finished cleanly
 *   error   - failed
 */

export type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

const STATUS_COLORS: Record<string, ChipColor> = {
  PENDING: "default",
  NOT_LOGGED_IN: "default",
  ECS_CONTAINER_STARTED: "info",
  LOGGED_IN: "info",
  PROCESSING: "primary",
  TWOFA: "warning",
  "2FA": "warning",
  STOPPED: "warning",
  FINISHED: "success",
  ERROR: "error",
  CRITICAL_ERROR: "error",
};

export function statusChipColor(status: string | null | undefined): ChipColor {
  return STATUS_COLORS[(status || "").toUpperCase()] ?? "default";
}

// Kept as named exports so the call sites read as before; both sides of a row
// now answer the same colour for the same word.
export const taskRunStatusChipColor = statusChipColor;
export const botWorkStatusChipColor = statusChipColor;
